import { render, staticRenderFns } from "./AdminSockets.vue?vue&type=template&id=0cc58125&"
import script from "./AdminSockets.vue?vue&type=script&lang=js&"
export * from "./AdminSockets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports